import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import Link from 'react-router/lib/Link';
// utils
import isEmpty from 'lodash.isempty';
import cn from 'classnames';
import { getFarmNickname, getUserNickname, getGroupNickname } from 'utils';
// styles
import styles from './ActivityMentions.module.scss';

// trucking-only users have no Barn Sheets, so their mentions stay plain text
const ActivityMentions = ({
  users = [], groups = [], group, farms = [], company, farm, isAdmin, isTruckingOnly, className,
}) => (
  <div className={cn(styles['activity-mentions'], className)}>
    {!isEmpty(company) && (
      <span className={styles['line-mention']}>
        <Link to={isTruckingOnly ? null : `/barnsheets/companies/${company.id}`}>
          @{getFarmNickname(company)}
        </Link>
      </span>
    )}
    {isEmpty(group) && !isEmpty(farm) && (
      <span className={styles['line-mention']}>
        <Link to={isTruckingOnly ? null : `/barnsheets/farms/${farm.id}`}>
          @{getFarmNickname(farm)}
        </Link>
      </span>
    )}
    {!isEmpty(group) && (
      <span className={styles['line-mention']}>
        <Link to={isTruckingOnly ? null : `/barnsheets/groups/${group.id}`}>
          @{getGroupNickname(group)}
        </Link>
      </span>
    )}
    {!isEmpty(groups) && (
      <span className={styles['line-mention']}>
        {groups.map((group) => (
          <Link key={group.id} to={isTruckingOnly ? null : `/barnsheets/groups/${group.id}`}>
            @{getGroupNickname(group)} &nbsp;
          </Link>
        ))}
      </span>
    )}
    {!isEmpty(farms) && (
      <span className={styles['line-mention']}>
        {farms.map((farm) => (
          <Link key={farm.id} to={isTruckingOnly ? null : `/barnsheets/farms/${farm.id}`}>
            @{getFarmNickname(farm)} &nbsp;
          </Link>
        ))}
      </span>
    )}
    {!isEmpty(users) && (
      <span className={styles['line-mention']}>
        {users.map((user) => (
          <Link key={user.id} to={isAdmin ? `/admin/users/${user.id}` : null}>
            @{getUserNickname(user)} &nbsp;
          </Link>
        ))}
      </span>
    )}
  </div>
);

ActivityMentions.propTypes = {
  className: T.string,
  users: T.array,
  company: T.object,
  group: T.object,
  groups: T.array,
  farm: T.object,
  farms: T.array,
  isAdmin: T.bool,
  isTruckingOnly: T.bool,
};

export default connect((state) => ({
  isTruckingOnly: Boolean(state.auth.user?.farmfeed_trucking_role),
}))(ActivityMentions);
